module.exports = __webpack_public_path__ + "Flama-Thin.woff?7cfa7c5ef1ef682b9c88fcc1c8acd782";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Thin.woff
// module id = 897
// module chunks = 0